
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import xheader from '../components/xheader.vue';
import xsilde from '../components/xsilde.vue';
export default {
components: {
xheader,
Tab,
TabItem,
xsilde
},
data() {
return {
index: NaN,
}
},
mounted(){
this.index = this.getIndex
},
computed:{
getIndex(){
if(this.$store.getters.Index) {
return parseInt(this.$store.getters.Index)
}
}
}
}



// WEBPACK FOOTER //
// ./src/views/App.vue